// extracted by mini-css-extract-plugin
export default {"calenderEventsMainSection":"meetingMessageOverviewSection_calenderEventsMainSection__Wqa7C"};